(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["turf-brand-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('turf-brand-carousel')) {
  customElements.define('turf-brand-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.tabs = [...this.querySelectorAll('[data-brand-tab]')];
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, {signal: this.abort.signal});
      const manual = index => { this.paused = true; this.show(index); this.schedule(); };
      this.tabs.forEach((tab, i) => {
        on(tab, 'click', () => manual(i));
        on(tab, 'keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (i + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); manual(next); this.tabs[next].focus(); }
        });
      });
      on(this.querySelector('[data-prev]'), 'click', () => manual(this.index - 1));
      on(this.querySelector('[data-next]'), 'click', () => manual(this.index + 1));
      on(this.querySelector('[data-pause]'), 'click', () => { this.paused = !this.paused; this.schedule(); });
      on(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', event => { if (!this.contains(event.relatedTarget)) { this.paused = true; this.schedule(); } });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.schedule(); });
      on(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target));
        if (index !== -1) manual(index);
      });
      this.schedule();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === this.index)); tab.tabIndex = i === this.index ? 0 : -1; });
    }
    schedule() {
      clearInterval(this.timer);
      const button = this.querySelector('[data-pause]');
      button.textContent = this.paused ? '▶' : 'Ⅱ';
      button.setAttribute('aria-pressed', String(this.paused));
      button.setAttribute('aria-label', this.paused ? 'Пускане на автоматичната смяна' : 'Спиране на автоматичната смяна');
      if (!this.paused && !this.hovered && !document.hidden && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 6500);
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.ready = false; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["turf-delivery-preferences"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('turf-delivery-preferences')) {
    customElements.define('turf-delivery-preferences', class extends HTMLElement {
      connectedCallback() {
        this.courier = this.querySelector('[data-turf-courier]');
        this.city = this.querySelector('[data-turf-city]');
        this.syncCity = () => {
          const local = this.courier.selectedOptions[0]?.hasAttribute('data-turf-sofia');
          this.city.readOnly = Boolean(local);
          if (local) this.city.value = this.dataset.sofiaCity;
        };
        this.courier.addEventListener('change', this.syncCity);
        this.syncCity();
      }
      disconnectedCallback() {
        this.courier?.removeEventListener('change', this.syncCity);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["turf-product-coverage"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input',function(event){if(!event.target.matches('.turf-area'))return;const box=event.target.closest('.turf-coverage');const area=Number(event.target.value);const result=box.querySelector('output');if(!Number.isFinite(area)||area<=0||area>1000000){result.textContent='';return}const min=area*Number(box.dataset.rateMin)/1000,max=area*Number(box.dataset.rateMax)/1000,pack=Number(box.dataset.pack);const format=n=>n.toLocaleString('bg-BG',{maximumFractionDigits:2});result.textContent=format(min)+(min!==max?'–'+format(max):'')+' кг · '+Math.ceil(min/pack)+(Math.ceil(min/pack)!==Math.ceil(max/pack)?'–'+Math.ceil(max/pack):'')+(Math.ceil(min/pack)===1&&Math.ceil(max/pack)===1?' опаковка според дозата':' опаковки според дозата');});
  } catch(e) { console.error(e); }
})();

})();
